export function hideLoadingIndicator(selector) {
	const container = document.getElementById(selector);
	container.classList.remove("loading");
	container.querySelector(".loader")?.classList.add("hidden");
}

export function showLoadingIndicator(selector) {
	const container = document.getElementById(selector);

	if (!selector || container.classList.contains("loading")) {
		return;
	}

	container.firstChild && container.replaceChildren();
	container.classList.add("loading");

	const existingLoader = container.querySelector(".loader");

	if (existingLoader) {
		existingLoader.classList.remove("hidden");
	} else {
		const loader = document.createElement("div");
		loader.classList.add("loader");
		container.appendChild(loader);
	}
}
